
    <div class="_404-content">
      <img src="assets/images/v2/EDG-Logo-Icon-White.svg" height="50" alt="" class="_404-logo" />
      <h2>Perhaps, you're wandering too far..</h2>
      <p>The page you are looking for doesn't exist or has been moved.</p>
      <a href="/"><app-form-button class="full-width primary">Go to home page</app-form-button></a>
    </div>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/page-not-found.component.ts.PageNotFoundComponent.html